<template>
  <v-snackbar
    v-model="snackbar.snackbar"
    :color="snackbar.snackbarColor"
    :bottom="snackbar.bottom"
    :right="snackbar.right"
    :top="snackbar.top"
    :left="snackbar.left"
    :timeout="snackbar.timeout"
     class="white--text"
  >
    {{ snackbar.message }}
    <v-btn flat color="red" @click.native="snackbar.snackbar = false"
      >Close</v-btn
    >
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    snackbar() {
      return this.$store.getters["general/getSnackbar"];
    }
  }
};
</script>
